import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { BewertungsAnlasssService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [BewertungsAnlasssService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class BewertungsAnlasssServiceModule {}
